<div class="flex flex-col gap-4">
  <p class="text-sm text-surface-500 dark:text-surface-400 m-0">
    {{ 'measurement.reschedule.window.help' | translate }}
  </p>

  <div class="flex flex-col gap-1">
    <label class="text-sm font-medium text-surface-700 dark:text-surface-300">
      {{ 'measurement.reschedule.window.start' | translate }}
    </label>
    <p-datepicker
      [(ngModel)]="startModel"
      [showTime]="true"
      [stepMinute]="1"
      hourFormat="24"
      dateFormat="dd/mm/yy"
      [minDate]="minDate"
      [maxDate]="maxDate"
      appendTo="body"
      styleClass="w-full"
    />
  </div>

  <div class="flex flex-col gap-1">
    <label class="text-sm font-medium text-surface-700 dark:text-surface-300">
      {{ 'measurement.reschedule.window.end' | translate }}
    </label>
    <p-datepicker
      [(ngModel)]="endModel"
      [showTime]="true"
      [stepMinute]="1"
      hourFormat="24"
      dateFormat="dd/mm/yy"
      [minDate]="minDate"
      [maxDate]="maxDate"
      appendTo="body"
      styleClass="w-full"
    />
  </div>

  <div class="flex items-center justify-between gap-2 pt-2">
    <p-button
      [label]="'measurement.reschedule.window.clear' | translate"
      icon="fa-solid fa-xmark"
      severity="secondary"
      [outlined]="true"
      (onClick)="clear()"
    />
    <div class="flex gap-2">
      <p-button
        [label]="'button.cancel' | translate"
        severity="secondary"
        [outlined]="true"
        (onClick)="cancel()"
      />
      <p-button [label]="'button.apply' | translate" (onClick)="apply()" />
    </div>
  </div>
</div>
